import { Link, useLocation } from "react-router-dom";
import { Youtube, Instagram, MessageCircle, Mail, Phone } from "lucide-react";
import { SOCIAL, COURSES } from "@/data/content";
import { Logo } from "./Logo";

export default function Footer() {
  const { pathname } = useLocation();
  if (pathname.startsWith("/dashboard") || pathname.startsWith("/admin")) return null;
  return (
    <footer data-testid="site-footer" className="relative z-10 mt-24 px-4 pb-8">
      <div className="glass max-w-7xl mx-auto rounded-[2rem] p-8 sm:p-12 grid gap-10 md:grid-cols-4">
        <div className="md:col-span-1">
          <Logo className="h-14" />
          <p className="mt-4 text-sm text-[var(--muted)] leading-relaxed">Her Hijab · Her Skills · Her Success. Online skill-learning for girls and women, from the comfort of home.</p>
        </div>
        <div>
          <h4 className="font-display text-xl font-semibold mb-4">Explore</h4>
          <ul className="space-y-2 text-sm text-[var(--muted)]">
            {[["/courses", "All Courses"], ["/packages", "Packages"], ["/instructors", "Instructors"], ["/contact", "Contact"]].map(([to, l]) => (
              <li key={to}><Link to={to} className="hover:text-[var(--pink)] transition-colors">{l}</Link></li>
            ))}
          </ul>
        </div>
        <div>
          <h4 className="font-display text-xl font-semibold mb-4">Popular Courses</h4>
          <ul className="space-y-2 text-sm text-[var(--muted)]">
            {COURSES.slice(0, 4).map((c) => (
              <li key={c.slug}><Link to={`/courses/${c.slug}`} className="hover:text-[var(--pink)] transition-colors">{c.title}</Link></li>
            ))}
          </ul>
        </div>
        <div>
          <h4 className="font-display text-xl font-semibold mb-4">Stay Connected</h4>
          <p className="text-sm text-[var(--muted)] flex items-center gap-2"><Mail size={15} /> {SOCIAL.email}</p>
          <p className="text-sm text-[var(--muted)] flex items-center gap-2 mt-2"><Phone size={15} /> {SOCIAL.phone}</p>
          <div className="flex gap-3 mt-5">
            {[[SOCIAL.youtube, Youtube, "youtube"], [SOCIAL.instagram, Instagram, "instagram"], [SOCIAL.whatsapp, MessageCircle, "whatsapp"]].map(([href, Icon, k]) => (
              <a key={k} href={href} target="_blank" rel="noreferrer" data-testid={`footer-${k}`} className="icon-orb !w-10 !h-10 hover:scale-110 transition-transform"><Icon size={18} /></a>
            ))}
          </div>
        </div>
      </div>
      <p className="text-center text-xs text-[var(--muted)] mt-6">© {new Date().getFullYear()} Ilmora Academy. All rights reserved.</p>
    </footer>
  );
}
